import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

import { useRestClient } from "@/lib/restClient";
import type { Tenant } from "@/types";

type TenantsResponse = {
  tenants: (Omit<Tenant, "tenant_id"> & { tenant_id: string | number })[];
  count: number;
};

export function useTenants() {
  const auth = useAuth();
  const apiFetch = useRestClient();

  return useQuery({
    queryKey: ["tenants"],
    queryFn: async ({ signal }) => {
      const data = await apiFetch<TenantsResponse>("/api/tenants", { signal });
      return data.tenants.map((tenant) => ({ ...tenant, tenant_id: String(tenant.tenant_id) }));
    },
    enabled:
      !auth.isLoading && auth.isAuthenticated && !!auth.user?.access_token && !auth.user.expired,
    staleTime: 5 * 60_000,
  });
}
